<template>
  <router-link :to="route">
    <i :class='icon' v-b-tooltip.hover :title="label"></i>
  </router-link>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    instance: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'Ordernar'
    },

    icon: {
      type: String,
      default: 'fa fa-sort'
    },

    to: {
      type: Object,
      default () { return {} }
    }
  },

  data () {
    return {
      //
    }
  },

  computed: {
    route () {
      if (isEmpty(this.to)) {
        return {
          path: `/bl-processes-order/?type_id=${this.instance.id}`,
          params: {
            entity: this.entity.key,
            id: this.instance.id
          }
        }
      }

      return this.to
    }
  },

  methods: {
    goToRoute () {
      this.$router.push(this.route)
    }
  }
}
</script>

<style lang="sass" scoped>
i
  cursor: pointer
  margin-right: 8px
</style>



// WEBPACK FOOTER //
// src/components/ui/DatatableElements/OrderElement.vue